import styles from './createRoom.module.scss';
import { OTooltip } from '@src/shared';
import { ScheduledMeetingsView, CreateMeetingAction } from '@src/components';

import useCreateRoom from './useCreateRoom';

import { FaCopy } from 'react-icons/fa';
import { FaArrowsRotate } from 'react-icons/fa6';
import { ToastContainer } from 'react-toastify';
import HomePage from '@src/assets/images/home/Group.png';

import { isWebView } from '@src/helpers/mediaDevices.helpers';

const CreateRoom = () => {
  const { generateRoom, onChangeRoomTitle, roomTitle, meetLink, onCopyRoomId, joinRoom } = useCreateRoom();

  return (
    <div id="create-room" className={styles.pageContainer}>
      {!isWebView() && (
        <section id="hero" className={styles.heroSection}>
          <div id="hero-container" className={styles.heroContainer}>
            <div id="hero-content" className={styles.heroContent}>
              <h3 id="title">Connect, collaborate, and celebrate anywhere</h3>
              <p id="subtitle">
                Experience secure, private, and effortless video conferencing like never before with Meet
              </p>
              <div className={styles.createRoomFormContainer}>
                <div id="create-room-form" className={styles.createRoomForm}>
                  <input
                    id="roomTitle"
                    className={styles.formInput}
                    type="text"
                    maxLength={36}
                    value={roomTitle}
                    onChange={onChangeRoomTitle}
                    placeholder="Enter meeting title"
                  />
                  <CreateMeetingAction joinRoom={joinRoom} />
                </div>
                <div id="meeting-id-container" className={styles.meetingIdContainer}>
                  <div id="meeting-id" className={styles.meetingId}>
                    Meeting: <span className={styles.meetingIdLink}>{meetLink}</span>
                  </div>
                  <div id="icons-group" className={styles.iconsGroup}>
                    <OTooltip id="copy-tooltip" title="Copy">
                      <div id="copy-icon" onClick={onCopyRoomId}>
                        <FaCopy id="copy-icon" />
                      </div>
                    </OTooltip>
                    <OTooltip id="refresh-tooltip" title="Refresh">
                      <div id="refresh-icon" onClick={generateRoom}>
                        <FaArrowsRotate id="refresh-icon" />
                      </div>
                    </OTooltip>
                  </div>
                </div>
              </div>
            </div>
            <img id="home-page-icon" src={HomePage} className={styles.imgIcon} alt="Icon" />
          </div>
        </section>
      )}
      <ScheduledMeetingsView />
      <ToastContainer />
    </div>
  );
};

export default CreateRoom;
